// Review SCAN vague 1, point 10 : deux caractères maximum — première lettre
// du premier mot + première lettre du dernier mot (prénom + nom), toujours en
// majuscules. Un seul mot = une seule lettre. « test 1 4 aout 2026 » donnait
// « T14A2 » : cinq caractères tassés dans un carré prévu pour deux.
export default function (name) {
  if (!name) { return "" }
  var parts = name.split(' ').filter(function (part) { return part.length > 0 })
  if (parts.length === 0) { return "" }
  if (parts.length === 1) { return parts[0][0].toUpperCase() }
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
}
